<template lang="pug">
div.reg-tea1st
  .row
    .col-md-12(v-if="error")
      .form-group(style="margin-top:15px")
        .alert.alert-danger(style="margin-bottom:10px") {{error}}
    .col-md-12(v-if="socialType === 1")
      md-fg-input(label='Tên đăng nhập *', v-model='username' :labelFloating='false', type='text' :required='true' placeholder="Nhập" @input="checkUserName"
        :class="[isSubmitStep && (username.length < 3 || checkName !== null) ? 'error' : '']")
      //- small(v-if="!username" style="color: red") *Tên đăng nhập không được bỏ trống*
    .col-md-12
      md-fg-input(label='Tên hiển thị *', v-model='fullname' :labelFloating='false', type='text' :required='true' placeholder="Nhập" maxlength=125
        :class="[isSubmitStep && fullname.length  === 0 ? 'error' : '']")
    .col-md-12
      md-fg-input(label='Email *', v-model='email' :labelFloating='false', type='email' :required='true' placeholder="example@gmail.com" v-if="socialType === 1"
        :class="[isSubmitStep && !validMail ? 'error' : '']")
      md-fg-input(label='Email *', v-model='email' :labelFloating='false', type='email' :disabled='true' placeholder="example@gmail.com" v-else)
    .col-md-12
      //- md-fg-input(label='Số điện thoại', v-model='phone_number' :labelFloating='false', type='text' :required='true' placeholder="Nhập")
      .form-group.custom-form-group(:class="[isSubmitStep && phone_number.length  === 0 ? 'error' : '']")
        label.control-label Số điện thoại
        input.form-control(type="text" 
          name="phone_number"
          placeholder="Nhập" 
          autocomplete="off" 
          v-model='phone_number'
          :required='false'
          maxlength = 10 
          @keypress="isAllow")
    .col-md-12
      md-fg-input(label='Ngày sinh của bạn', v-model='birthday' :labelFloating='false', type='date' :required='false'
        :class="[isSubmitStep && isDate ? 'error' : '']")
    .col-md-12
      .form-group.custom-form-group
        label.control-label Trường bạn đang công tác
        select#school_id.form-control(@change='onChangeSchool($event)')
          option(selected='true' disabled) Chọn
          option(v-for='(o, index) in schools' :value='o.id' :selected="o.id === selectedSchool") {{o.name}}
    .col-md-12(v-if="socialType === 1")
      //- md-fg-input(label='Mật khẩu đăng nhập *', v-model='password' :labelFloating='false', type='password' :required='true')
      .form-group.custom-form-group(style='position:relative;' :class="[isSubmitStep && this.password.length < 6 ? 'error' : '']")
        label.control-label Mật khẩu đăng nhập *
        input#password.form-control(v-model="password" :type='passwordType' required style='padding-right: 40px !important;' @keyup='checkPassword' placeholder="Nhập")
        i.material-icons.reg-tea1st-icon-password(@click="switchVisibility1st" v-if="passwordType === 'text'") visibility
        i.material-icons.reg-tea1st-icon-password(@click="switchVisibility1st" v-else) visibility_off
        //- small(v-if="!must6digit" style="color: red; margin-top: -10px;") (Mật khẩu phải ít nhất 6 ký tự)
    .col-md-12(v-if="socialType === 1")
      .form-group.custom-form-group(style='position:relative;' :class="[isSubmitStep && (!this.matched || this.second_password.length < 6) ? 'error' : '']")
        label.control-label Nhập lại mật khẩu *
        input#second_password.form-control(v-model="second_password" :type='secondPasswordType' required style='padding-right: 40px !important;' @keyup='checkPassword' placeholder="Nhập")
        i.material-icons.reg-tea1st-icon-password(@click="switchVisibility2nd" v-if="secondPasswordType === 'text'") visibility
        i.material-icons.reg-tea1st-icon-password(@click="switchVisibility2nd" v-else) visibility_off
        //- small(v-if="!matched" style="color: red") *Mật khẩu không khớp*

    .col-md-12.lo-custom-footer
      div.col-md-6.col-12
        div.text-right
          button.reg-tea1st-btn-validate.btn(@click='validateContinue') Tiếp tục
      div.col-md-6.col-12
        div.text-left
          button.reg-tea1st-btn-cancel.btn(@click="backLogin") Quay lại

</template>

<script>
import store from '../../store'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
export default {
  components: {
    MdNotification,
    moment
  },
  props: {
    schools: Array,
    newEmail: String,
    newFullName: String,
    socialType: Number,
    newParams: Object,
    oldData: Object
  },
  data() {
    return {
      username: this.newEmail !== undefined ? this.newEmail : '',
      birthday: new Date().toISOString().slice(0, 10),
      fullname: this.newFullName !== undefined ? this.newFullName : '',
      phone_number: '',
      email: this.newEmail !== undefined ? this.newEmail : '',
      password: '',
      second_password: '',
      isSelectedSchool: false,
      selectedSchool: null,
      continue: false,
      matched: true,
      passwordType: 'password',
      secondPasswordType: 'password',
      error: null,
      must6digit: true,
      passwordError: [],
      spasswordError: [],
      params: this.newParams,
      checkName: null,
      front_params: null,
      isDate: false,
      isSubmitStep: false,
      validMail: false
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    switchVisibility1st() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    switchVisibility2nd() {
      this.secondPasswordType = this.secondPasswordType === 'password' ? 'text' : 'password'
    },
    switchVisibilityCaptcha() {
      this.captchaType = this.captchaType === 'password' ? 'text' : 'password'
    },
    checkDigit(e) {
      if (e.target.value.length < 6) {
        this.must6digit = false
        // this.passwordError = ['has-error']
      } else {
        this.must6digit = true
        if (this.second_password !== this.passwordType) this.matched = false
      }
    },
    isAllow(event) {
      var key = window.event ? event.keyCode : event.which
      if (event.keyCode === 8 || event.keyCode === 46) {
        return true
      } else if (key < 48 || key > 57) {
        event.preventDefault()
        return false
      } else {
        return true
      }
    },
    checkPassword(e) {
      if (this.second_password !== this.password) {
        this.matched = false
      } else {
        this.matched = true
      }
    },
    onChangeSchool(e) {
      var id = e.target.value
      this.isSelectedSchool = true
      this.selectedSchool = parseInt(id)
    },
    checkUserName(username) {
      if (this.username !== null) {
        this.$apollo.queries.checkName.refresh()
      }
    },
    checkDate() {
      this.isDate = false
      var date1 = new Date()
      date1 = moment(date1)
      var date2 = moment(this.birthday)
      if (date1 < date2) {
        this.isDate = true
      }
    },
    checkMail(text) {
      this.validMail = false
      if (text.length > 0) {
        if ((text.split('@').length - 1) < 1 || (text.split('@').length - 1) > 1) {
          this.validMail = false
        } else {
          let arrText = text.split('@')[1]
          if (arrText.length === 0) this.validMail = false
          else {
            let lastText = arrText.split('.').length
            if (lastText >= 2) this.validMail = true
            else this.validMail = false
          }
        }
      }
    },
    validateContinue() {
      // lấy giá trị fields đưa lên parent
      var data = {
        fullname: this.fullname,
        username: this.username,
        email: this.email,
        phone_number: this.phone_number,
        school_id: this.selectedSchool,
        birthday: this.birthday,
        password: this.second_password
      }
      // đăng ký accout thường
      if (this.socialType === 1) {
        this.$apollo.queries.checkName.refresh()
        this.checkDate()
        this.checkMail(this.email)
        if (this.checkName !== null) {
          this.showNotification('Tên đăng nhập đã tồn tại', 'warning', 'top', 'right', 2000)
          this.error = 'Tên đăng nhập đã tồn tại'
          this.isSubmitStep = true
        } else if (this.username.length < 3) {
          this.showNotification('Tên đăng nhập phải có ít nhất 3 kí tự', 'warning', 'top', 'right', 2000)
          this.error = 'Tên đăng nhập phải có ít nhất 3 kí tự'
          this.isSubmitStep = true
          console.log()
        } else if (this.fullname.length === 0) {
          this.showNotification('Vui lòng nhập tên hiển thị', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng nhập tên hiển thị'
          this.isSubmitStep = true
        } else if (this.email.length === 0) {
          this.showNotification('Vui lòng nhập Email', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng nhập Email'
          this.isSubmitStep = true
        } else if (!this.validMail) {
          this.showNotification('Vui lòng xem lại định dạng Email', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng xem lại định dạng Email'
          this.isSubmitStep = true
        } else if (this.phone_number.length === 0) {
          this.showNotification('Vui lòng nhập số điện thoại', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng nhập số điện thoại'
          this.isSubmitStep = true
        } else if (this.isDate) {
          this.showNotification('Ngày sinh không được là ngày trong tương lai', 'warning', 'top', 'right', 2000)
          this.error = 'Ngày sinh không được là ngày trong tương lai'
          this.isSubmitStep = true
        } else if (this.password.length < 6) {
          this.showNotification('Mật khẩu phải có ít nhất 6 kí tự', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng nhập mật khẩu'
          this.isSubmitStep = true
        } else if (!this.matched) {
          this.showNotification('Mật khẩu nhập lại không khớp', 'warning', 'top', 'right', 2000)
          this.error = 'Mật khẩu nhập lại không khớp'
          this.isSubmitStep = true
        } else if (this.matched && this.must6digit && this.username && this.fullname && this.email && this.second_password) {
          this.$emit('continueTeacher', data)
        } else {
          this.showNotification('Vui lòng kiểm tra lại thông tin Tên hiển thị, Tên đăng nhập, Email, Mật khẩu', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng kiểm tra lại thông tin Tên hiển thị, Tên đăng nhập, Email, Mật khẩu'
        }
      } else {
        this.$emit('continueTeacher', data)
      }
    },
    backLogin() {
      if (this.socialType === 2) {
        store.dispatch('signOutAction')
        store.commit('setIsLoggedIn', false)
      }
      store.commit('setIsHomePage', false)
      if (this.front_params && this.front_params.name !== null) {
        store.commit('setIsHomePage', true)
        let params = this.front_params
        let name = params.name
        this.$delete(params, 'name')
        this.$router.push({name: name, params: params})
      } else this.$router.push('login')
    }
  },
  mounted() {
    if (this.$route.params.front_top !== undefined && this.$route.params.front_top) {
      this.front_params = this.$route.params
    }
    if (this.oldData !== null && this.oldData !== undefined) {
      this.username = this.oldData.username
      this.fullname = this.oldData.fullname
      this.birthday = this.oldData.birthday
      this.phone_number = this.oldData.phone_number
      this.email = this.oldData.email
      this.password = this.oldData.password
      this.second_password = this.oldData.password
      this.selectedSchool = this.oldData.school_id
    }
  },
  apollo: {
    checkName: {
      query: gql(graphql.GET_USER_PUBLIC),
      fetchPolicy: 'no-cache',
      variables() {
        return { username: this.username }
      },
      update: data => {
        // console.log('apollo: ', data)
        if (data && data.v_user_public && data.v_user_public.length === 0) {
          return null
        } else {
          return data.v_user_public[0].username
        }
      },
      skip() {
        return this.username === null || this.username === undefined || this.username === ''
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-reg-tea1st-button: #FFD311;
}
.reg-tea1st {
  .form-group {
    &.error{
      input, select{border: 1px solid #f00;}
      span.required{display: block; color: #f00; text-align: left;}
    }
  }
}
.reg-tea1st-password {
  width: 100%
}
.reg-tea1st-icon-password {
  margin-top: -43px; 
  display:block;
  position:absolute;
  right:10px;
  padding:auto 5px;
  &:hover {
    cursor: pointer;
  }
}
.reg-tea1st-btn-validate {
  background: var(--color-reg-tea1st-button);
  color:black;
  text-transform: none;
  font-size: 13px;
  border: 1px solid var(--color-reg-tea1st-button);
  border-radius: 5px;
  // box-shadow: 0px 0px 0px;
  width: 160px;
  margin-bottom: 20px;
  &:hover {
    color: black;
    background: var(--color-reg-tea1st-button);
  }
}
.reg-tea1st-btn-cancel {
  background: white;
  color: black;
  text-transform: none;
  font-size: 13px;
  border: 1px solid var(--color-reg-tea1st-button);
  border-radius: 5px;
  // box-shadow: 0px 0px 0px;
  width: 160px;
  &:hover {
    color: black;
    background: white;
  }
}
@media (max-width: 991px) {
  .lo-custom-footer{text-align: center;
    .col-12{display: inline-block;
      .reg-tea1st-btn-validate{float: none; margin-bottom:15px; margin-left: 0;}
      .reg-tea1st-btn-cancel{float: none;  margin-bottom:15px; margin-right: 0;}
    }
  }
  // .reg-tea1st {
  //   .form-group {
  //     &.error{
  //       input, select{border: 1px solid #f00;}
  //       span.required{display: block; color: #f00; text-align: left;}
  //     }
  //   }
  // }
}

// cellphones
@media (max-width: 414px) {
  .reg-tea1st-btn-validate {
    float: left;
    width: 115px !important;
  }
  .reg-tea1st-btn-cancel {
    float: right;
    width: 115px !important;
  }
}

</style>



// WEBPACK FOOTER //
// itemRegisterTeacher1.vue?241798f7